import React, { useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { register } from "./authenticationAPI";

const Register = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const response = await register(
        formData.name,
        formData.companyName,
        formData.email,
        formData.password,
        formData.confirmPassword,
        "https://sinnovar-uat.vercel.app/verify-register"
      );
      if (response.status === 201 || response.status === 200) {
        navigate(route.login);
      } else {
        setError("Registration failed. Please try again.");
      }
    } catch (error: any) {
      if(error.response?.data?.code != 500){
        setError(error.response?.data?.message || "Unknown error");
      }
    }

    setLoading(false);
  };


  return (
    <div className="account-content">
      <div className="d-flex align-items-center justify-content-center flex-wrap w-100 vh-100 overflow-hidden account-bg-02">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleRegister}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath src="assets/img/logo.svg" className="img-fluid" alt="Logo" />
              </div>
              <div className="mb-4">
                <h4 className="mb-2 fs-20">Register</h4>
                <p>Create a new CRMS account</p>
              </div>
              {error && <p className="text-danger">{error}</p>}
              <div className="mb-3">
                <label className="col-form-label">User Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="col-form-label">Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? "Registering..." : "Sign Up"}
                </button>
              </div>
              <div className="mb-3">
                <h6>
                  Already have an account?{" "}
                  <Link to={route.login} className="text-purple link-hover">
                    {" "} Sign In Instead
                  </Link>
                </h6>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
